module.exports = __webpack_public_path__ + "4fac3304eb6b3fc16d30a98cfb42c8e7.pdf";